import { marker as _} from '@biesbjerg/ngx-translate-extract-marker';

export function gettext(a: string): string {
  return _(a) as string;
}
